export const selectRecentlyViewed = state => state.recent.items;

export const selectIsOpen = state => state.recent.isOpen;
